module.exports = __webpack_public_path__ + "static/media/playButton.77c49bf2.svg";